/**
 * 用途: フロントエンドのXSS対策として、DomSanitizerの利用を一元化するサービス。
 * - HTML/URL/ResourceURL を sanitize() で無害化した上で、Safe* 型に変換します。
 * - コンポーネントやパイプから直接 bypassSecurityTrust* を呼ばない運用を徹底し、安全な経路を提供します。
 */
import { inject, Injectable, SecurityContext } from '@angular/core';
import { DomSanitizer, SafeHtml, SafeResourceUrl, SafeUrl, } from '@angular/platform-browser';

@Injectable({providedIn: 'root'})
export class SanitizerService {
  // Angular v20+ の推奨: inject() によるDI
  private readonly domSanitizer = inject(DomSanitizer);

  /**
   * 任意HTMLを sanitize した上で SafeHtml に変換して返す
   * 注意: リンク化や任意タグ許可などの拡張は別レイヤーで行い、ここでは最小限のサニタイズを担います。
   */
  safeHtml(input: string | null | undefined): SafeHtml {
    const sanitized = this.domSanitizer.sanitize(SecurityContext.HTML, input ?? '') ?? '';
    return this.domSanitizer.bypassSecurityTrustHtml(sanitized);
  }

  /**
   * 任意URLを sanitize した上で SafeUrl に変換して返す
   */
  safeUrl(url: string | null | undefined): SafeUrl {
    const sanitized = this.domSanitizer.sanitize(SecurityContext.URL, url ?? '') ?? '';
    return this.domSanitizer.bypassSecurityTrustUrl(sanitized);
  }

  /**
   * リソースURL（iframe src, media src 等）を sanitize した上で SafeResourceUrl に変換して返す
   */
  safeResourceUrl(url: string | null | undefined): SafeResourceUrl {
    const sanitized = this.domSanitizer.sanitize(SecurityContext.RESOURCE_URL, url ?? '') ?? '';
    return this.domSanitizer.bypassSecurityTrustResourceUrl(sanitized);
  }
}
